import React from 'react';

type Props = {
  name: string;
  isClientOnly: boolean;
  onChange: (isClientOnly: boolean) => void;
  currentIsClientOnly?: boolean;
};

const options = [
  { isClientOnly: false, title: 'Full Firm Access' },
  { isClientOnly: true, title: 'Client-Only Firm Access' },
];

const AccessTypeOptions = ({ name, isClientOnly, onChange, currentIsClientOnly }: Props) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 4 }}>
    {options.map(option => {
      const isCurrent = currentIsClientOnly === option.isClientOnly;
      const id = `${name}-${option.isClientOnly ? 'clientonly' : 'full'}`;
      return (
        <label
          key={id}
          htmlFor={id}
          style={{ display: 'flex', alignItems: 'center', gap: 8, margin: 0, fontSize: 14, color: isCurrent ? '#9ca3af' : '#1a1a19' }}
        >
          <input
            id={id}
            type="radio"
            name={name}
            checked={option.isClientOnly === isClientOnly}
            disabled={isCurrent}
            onChange={() => onChange(option.isClientOnly)}
            style={{ width: 16, height: 16, margin: 0, opacity: 1, accentColor: '#2563EB' }}
          />
          {option.title}
          {isCurrent && <span style={{ fontSize: 12 }}>(current)</span>}
        </label>
      );
    })}
  </div>
);

export default AccessTypeOptions;
